module.exports = "pegasus/assets/blocks/header-4-tech.png";